export const REGULATION_OPTIONS = [
  { label: 'Semua Peraturan', value: 'Semua Peraturan' },
  { label: 'Peraturan OSS (Online Single Submission)', value: 'Peraturan OSS (Online Single Submission)' },
  { label: 'Peraturan Pendirian Badan Usaha', value: 'Peraturan Pendirian Badan Usaha' },
  { label: 'Peraturan Perizinan dan Pendaftaran', value: 'Peraturan Perizinan dan Pendaftaran' },
  { label: 'Peraturan KBLI dan DNI', value: 'Peraturan KBLI dan DNI' },
  { label: 'Peraturan terkait Lainnya', value: 'Peraturan terkait Lainnya' }
]

export const SIZE_OPTIONS = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '15', value: '15' }
]
